





































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class MobileAppBar extends Vue {
  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  voteList: string[] = ['Angular', 'React', 'Vue', 'Svelte'];
}
